import { FileAudio, FileText, FileVideo, ImageIcon, LinkIcon, type LucideIcon } from "lucide-react";

import type { LinkPayload, LinkPreviewKind } from "@/routes/smart-table/utils/contentType";

const LINK_PREVIEW_ICON_BY_KIND: Record<LinkPreviewKind, LucideIcon> = {
  image: ImageIcon,
  video: FileVideo,
  audio: FileAudio,
  pdf: FileText,
  link: LinkIcon,
};

export const getLinkPreviewIcon = (kind: LinkPreviewKind): LucideIcon =>
  LINK_PREVIEW_ICON_BY_KIND[kind] ?? LinkIcon;

export const coerceLinkPayload = ({
  rawValue,
  displayPreview,
  linkPayload,
}: {
  rawValue: unknown;
  displayPreview: string;
  linkPayload?: LinkPayload;
}): LinkPayload | null => {
  if (linkPayload) {
    return linkPayload;
  }

  if (typeof rawValue !== "string") {
    return null;
  }

  return {
    url: rawValue,
    label: displayPreview || rawValue,
    kind: "link",
  };
};
